module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down-white.c3b75b17.svg";